import request from '@/utils/request'

export default {
  getBrokerAccounts(qry) {
    return request.post('/reference-data/getBrokerAccounts', qry)
  },
  createBrokerAccount(createBrokerAccountReq) {
    return request.post(
      '/reference-data/createBrokerAccount',
      createBrokerAccountReq
    )
  },
  updateBrokerAccount(brokerAccountDTO) {
    return request.post('/reference-data/updateBrokerAccount', brokerAccountDTO)
  },
}
